
export const Authorize = (role: string[], acceptedRole: string[]) => {
    let authorized = false;

    acceptedRole.forEach((item) => {
        let exis = role.find((x) => x === item);
        if (exis) {
            authorized = true;
            return;
        }
    });

    return authorized;
}